import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import logo from "@/assets/brand/note-console-logo-transparent.png";
import OrderNowLink from "@/components/OrderNowLink";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  const links = [
    { to: "/#pdf-showcase", label: "Pages" },
    { to: "/#book-video-preview", label: "Book Video Preview" },
    { to: "/#how", label: "How It Works" },
    { to: "/#features", label: "Features" },
    { to: "/#order", label: "Order" },
  ];

  return (
    <nav
      data-testid="public-navbar"
      className="sticky top-0 z-40 bg-retro-bg/85 backdrop-blur-md border-b-[3px] border-retro-ink"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <img src={logo} alt="Note Console" className="h-12 w-auto object-contain transition-transform group-hover:scale-[1.03] sm:h-14 md:h-16" />
        </Link>

        <ul className="hidden md:flex items-center gap-5 font-body font-medium text-sm lg:gap-7">
          {links.map((l) => (
            <li key={l.to}>
              <a href={l.to} className="hover:text-retro-purple transition-colors" data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}>
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <OrderNowLink
            source="nav-desktop"
            className="retro-btn bg-retro-pink text-retro-ink px-4 py-2 text-sm"
            data-testid="nav-order-now-btn"
          />
          {user ? (
            <Link
              to="/admin"
              className="retro-btn bg-retro-purple text-white px-4 py-2 text-sm"
              data-testid="nav-admin-btn"
            >
              Admin
            </Link>
          ) : (
            <Link to="/login" className="retro-btn bg-retro-purple text-white px-4 py-2 text-sm" data-testid="nav-login-btn">
              Admin Login
            </Link>
          )}
        </div>

        <button
          className="md:hidden retro-btn p-2 bg-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-[3px] border-retro-ink bg-white px-5 py-4 flex flex-col gap-3" data-testid="mobile-menu">
          {links.map((l) => (
            <a key={l.to} href={l.to} onClick={() => setOpen(false)} className="font-body font-medium">
              {l.label}
            </a>
          ))}
          <OrderNowLink source="nav-mobile" onClick={() => setOpen(false)} className="retro-btn bg-retro-pink text-retro-ink px-4 py-2 text-sm text-center" />
          {user ? (
            <Link to="/admin" className="retro-btn bg-retro-purple text-white px-4 py-2 text-sm text-center">
              Admin
            </Link>
          ) : (
            <Link to="/login" className="retro-btn bg-retro-purple text-white px-4 py-2 text-sm text-center">
              Admin Login
            </Link>
          )}
        </div>
      )}
    </nav>
  );
}
